import { supabase } from './supabase';

// Inserta una fila en la tabla `metrics` de Supabase.
// user_id es nullable — los usuarios anónimos también generan métricas.
// Nunca bloquea el flujo de la app (fire-and-forget).
export const registrarMetrica = async (userId, paeType, event) => {
  const { error } = await supabase.from('metrics').insert({
    user_id: userId || null,
    pae_type: paeType,
    event,
  });
  if (error) console.warn('[metrics] insert failed:', error.message);
};
